import { render, staticRenderFns } from "./VerCrearModal.vue?vue&type=template&id=39074bca&"
import script from "./VerCrearModal.vue?vue&type=script&lang=ts&"
export * from "./VerCrearModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('39074bca', component.options)
    } else {
      api.reload('39074bca', component.options)
    }
    module.hot.accept("./VerCrearModal.vue?vue&type=template&id=39074bca&", function () {
      api.rerender('39074bca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/TiposProducto/VerCrearModal.vue"
export default component.exports